export enum HttpMethod {
  Delete = "DELETE",
  Get = "GET",
  Post = "POST",
  Put = "PUT"
}

export enum HttpStatus {
  CONFLICT = 409,
  INTERNAL_SERVICE_ERROR = 500
}

export interface ISearchParams {
  [key: string]: string;
}

abstract class HttpService {
  public static generateUrl = (
    apiUrlPath: string,
    resourcePath: string,
    serverUrl: string,
    searchParams?: ISearchParams
  ) => {
    const url = new URL(`${apiUrlPath}${resourcePath}`, serverUrl);
    if (searchParams) {
      Object.entries(searchParams).forEach(searchParam => {
        const [key, value] = searchParam;
        url.searchParams.append(key, value);
      });
    }
    return url;
  };
}

export default HttpService;
